import { Button, Card, H1, H3, H4, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import EventsCard from "./EventsCard";
import { Footer } from "./Footer";

export const SiteUnderConstructionCard = () => {
  // Existing states
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Existing images loading
    const image = new Image();
    image.src = "/work-deadline-4.svg";
    image.onload = () => setImageLoaded(true);
  }, []);

  // Return null or loading spinner if images are not loaded
  if (!imageLoaded) {
    return null; // or return a loading spinner or any placeholder content
  }

  return (
      <div className="site-container">
        <div className="container">
          <img
              src="/work-deadline-4.svg"
              alt="Work Deadline"
              className="deadline-image" // Use className for styling
          />
          <H1 className="card-header">РАСПИСАНИЕ МАСТЕР-КЛАССОВ</H1>
          <div className="row">
            <Card className="card-inside-container" elevation={4}>
              <Tag className="location-tag" large>МОСКВА</Tag>
              <Tag className="location-product-tag" large intent={"warning"}>АФРО ТОДЕС</Tag>
              <H3>МАСТЕР-КЛАСС ДИМЫ АЛЕКСАНДРОВА</H3>
              <H4>16 июля 2024</H4>
              <p className="event-description">
                В свой День рождения Дима собирает людей, которые любят танцевать! Мастер-класс по афродэнс и погружение в афрокультуру. Дима уже два раза посетил в Южную Африку, танцевал с носителями. Вы узнаете про африканские направления, потанцуете под музыку гком и степы из стиля Бенга. И сможете узнать, как появился самый популярный стиль и в чем его особенность!
              </p>
              <Button
                  icon="shopping-cart"
                  text="Оформить билет"
                  intent="success"
                  large
                  onClick={() =>
                      (window.location.href =
                          "https://masterclass.todes.ru/event/AGF7IA")
                  }
              />
            </Card>
          </div>
        </div>
        {/*<EventsCard/>*/}
        <Footer/>
      </div>
  );
};
